<template>
  <div class="upload-files">
    <el-upload
      class="upload-demo"
      action="#"
      :limit="limit"
      :show-file-list="showFileList"
      :multiple="false"
      :auto-upload="true"
      :on-remove="onRemove"
      :on-exceed="handleExceed"
      :before-upload="beforeUpload"
      :file-list="fileList">
      <el-button v-if="isUploadBtn" :class="isBtnBlueText?'upload-blue-btn':'upload-btn'" size="small" type="primary">{{btnText}}</el-button>
      <div v-if="isUploadText" slot="tip" class="el-upload__tip">请上传word,excel文件，大小不超过5M</div>
    </el-upload>
  </div>
</template>

<script>
import ImgUploader from '@/models/img-upload'
const imgUploader = new ImgUploader();
export default {
  props: {
    image: {
      type: Array
    },
    fileArr: {
      type: Array
    },
    isFileStream: {
      type: Boolean,
      default: false
    },
    isUploadTextCopy: {
      type: Boolean,
      default: true
    },
    showFileList: {
      type: Boolean,
      default: true
    },
    btnText: {
      type: String,
      default: '上传'
    },
    isBtnBlueText: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      /* 上传文件数据 */
      fileList: this.fileArr,
      images: this.image,
      isUploadBtn: true,
      isUploadText: this.isUploadTextCopy
    }
  },

  created() {
  },

  mounted() {
    this.$bus.on('clearImgFiles', v => {
      this.fileList = []
      this.images = []
      this.isUploadBtn = true
      this.isUploadText = true
    })
    this.$bus.on('init', v => {
      this.fileList = v.fileList
      this.images = v.images
      this.isUploadBtn = true
      this.isUploadText = true
    })
  },

  methods: {
    /* 上传文件进行文件格式判断 */
    beforeUpload(file) {
      let isFile = null
      if (file.type) {
        isFile =
          file.type === "application/msword"||
          file.type === "application/vnd.ms-excel" ||
          file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else {
        isFile = file.name.endsWith('.xlsx') || file.name.endsWith('.xls') || file.name.endsWith('.doc') || file.name.endsWith('.docx')
      }
      console.log("file.type="+file.type)
      console.log("file.name="+file.name)
      const isLt5M = file.size / 1024 / 1024 / 1024 / 1024 / 1024 < 5;
      if (!isFile) {
        this.$message.error("上传文件格式错误!");
        return false;
      } else if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
        return false;
      } else {
        this.isUploadText = false
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then(res => {
            if (res.errorCode === 0) {
              this.$nextTick(() => {
                let obj = {};
                obj.url = res.imgUrl;
                obj.name = file.name;
                this.fileList.push(obj);
                this.images = [];
                if (!this.isFileStream) {
                  this.fileList.map((value, index, Array) => {
                    this.images.push(value.url);
                    this.$emit('uploadFile', this.images)
                  })
                } else {
                  this.images.push(file)
                  this.$emit('uploadFile', this.images)
                };
              })
            } else {
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.$message.error("图片上传超时，请重新上传");
          });
      }
    },
    /* 文件超出个数限制时 */
    handleExceed() {
      this.$message({
        message: `文件上传数量最多${this.limit}张`,
        type: "warning",
      });
    },
    /* 删除文件 */
    onRemove(file, fileList) {
      this.fileList = fileList;
      this.images = [];
      this.fileList.map((value, index, Array) => {
        this.images.push(value.url);
      });
      this.$emit('uploadFile', this.images)
      this.isUploadText = true
    }
  }
}
</script>

<style lang='scss'>
.upload-files {
  .upload-btn {
    width: 80px;
    height: 30px;
    font-weight: 400;
    line-height: 10px;
    border-radius: 2px;
    color: $color-grey;
    font-size: $fs-small-l;
    background: $upload-btn;
    border: 1px solid $bg-LightSnow;
  }
  .upload-blue-btn {
    width: 80px;
    height: 30px;
    font-weight: 400;
    line-height: 10px;
    border-radius: 2px;
    font-size: $fs-small-l;
    border: 1px solid $bg-DeepReddishBlue;
    background: $bg-white;
    color: $color-DepartmentPeople;
  }
  .el-upload__tip {
    font-weight: 400;
    line-height: 16px;
    font-size: $fs-small-m;
    color: $color-LightGrey;
    text-align: left;
  }
  .upload-demo {
    .el-upload {
      width: 100%;
      display: flex;
      justify-content: flex-start;
    }
    .el-upload-list--text {
      height: 30px;
      padding-top: 3px;
      box-sizing: border-box;
      .el-upload-list__item:first-child {
        margin-top: 0px;
      }
      .el-upload-list__item {
        margin-top: 0px;
      }
      .el-upload-list__item-name {
        font-weight: 400;
        font-size: $fs-small-l;
        color: $color-ReddishBlue;
        text-align: left;
        .el-icon-document {
          display: none;
        }
        .el-icon-upload-success {
          display: none;
        }
      }
    }
  }
}
</style>
